import { Alert, Button, Icon, Text } from "@alpacahq/ui/old";

import { FAQ } from "~/v2/components/common/FAQ";
import { Layout } from "../../common/Layout";
import { ACH_FAQ } from "./achFaq";
import { type PlaidStatus, PlaidStatusPanel } from "./PlaidStatusPanel.pres";

export interface LinkACHPresentationProps {
  status: PlaidStatus;
  isPlaidReady: boolean;
  isVerifyingMicroDeposit: boolean;
  showAlreadyLinked: boolean;
  isFullscreen: boolean;
  onOpenPlaid: () => void;
  onBack: () => void;
}

export const LinkACHPresentation = ({
  status,
  isPlaidReady,
  isVerifyingMicroDeposit,
  showAlreadyLinked,
  isFullscreen,
  onOpenPlaid,
  onBack,
}: LinkACHPresentationProps) => {
  return (
    <Layout
      title="Direct Bank Transfer (ACH)"
      subtitle="Link a bank account to deposit and withdraw funds through Plaid."
      faq={<FAQ faq={ACH_FAQ} />}
    >
      <Button onClick={onBack} variant="secondary" className="mb-8">
        <Icon name="ArrowLeftCircle" className="mr-2" /> Back
      </Button>

      <Text className="pb-4 font-semibold text-xl">Plaid Connection</Text>

      <Alert
        className="mb-4"
        message={
          <span className="flex gap-4">
            <Icon name="InformationCircle" />
            <span>
              Note: Your bank account needs to <b>match</b> the name of your
              Alpaca brokerage account.
            </span>
          </span>
        }
        variant="info"
      />

      <PlaidStatusPanel
        status={status}
        isPlaidReady={isPlaidReady}
        isVerifyingMicroDeposit={isVerifyingMicroDeposit}
        showAlreadyLinked={showAlreadyLinked}
        isFullscreen={isFullscreen}
        onOpenPlaid={onOpenPlaid}
        onBack={onBack}
      />
    </Layout>
  );
};
